import { useCallback, useMemo, useState } from 'react'
import { allowCookies, getConsentStatus } from 'app/cookiesEvents'

/**
 * The `useCookies` hook
 *
 * @returns {object} the context object
 */
function useCookies () {
  const [hasCookieConsent, setHasCookieConsent] = useState(getConsentStatus())

  const onAcceptCookies = useCallback(() => {
    allowCookies()
    setHasCookieConsent(true)
  }, [])

  const ctx = useMemo(
    () => ({
      hasCookieConsent,
      onAcceptCookies
    }),
    []
  )

  return ctx
}

// Export
export default useCookies
